"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'UserList',
  props: {
    userType: {
      type: String,
      default: 'collect'
    }
  },
  data: function data() {
    return {
      templateRadio: 0,
      tableFrom: {
        page: 1,
        limit: 10,
        nikename: '',
        searchType: 'all',
        content: '',
        userType: this.userType
      },
      tableData: [],
      total: null
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    changeRow: function changeRow(row) {
      // this.selectedRow = row;
      this.$emit('getRow', row);
    },
    initList: function initList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      (0, _user.userListApi)(this.tableFrom).then(function (res) {
        _this.tableData = res.list;
        _this.total = res.total;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //页数更改
    handleCurrentChange: function handleCurrentChange(val) {
      this.tableFrom.page = val;
      this.getList();
    }
  }
};